import { IEmotionRecordDTO } from "motw_core/DTOs/IEmotionRecordDTO";
import * as React from "react";
import {
    Bar,
    BarChart,
    Cell,
    ReferenceLine,
    Tooltip,
    XAxis,
    YAxis,
} from "recharts/lib";
import { GetEmotionValuePercentColor } from "source/app/presentation/MainPanel/KeyValueLogs/KeyValueLogs";

export function EmotionChart({
    emotionRecords,
}: {
    emotionRecords: IEmotionRecordDTO[];
}) {
    return (
        <div>
            <BarChart
                width={260}
                height={120}
                data={emotionRecords}
                margin={{ top: 0, right: 30, left: 0, bottom: 0 }}
            >
                <XAxis dataKey="endDate" hide />
                <YAxis type="number" domain={[50, 100]} />
                {[87.5, 75, 62.5, 50].map((value) => (
                    <ReferenceLine
                        y={value}
                        stroke={GetEmotionValuePercentColor(value)}
                        strokeDasharray="3 3"
                    />
                ))}
                <Bar dataKey="percentValue">
                    {emotionRecords.map((entry, index) => (
                        <Cell
                            key={`cell-${index}`}
                            fill={GetEmotionValuePercentColor(
                                entry.percentValue
                            )}
                        />
                    ))}
                </Bar>
                <Tooltip
                    content={(props: any) => <ChartTooltip props={props} />}
                />
            </BarChart>
        </div>
    );
}

function ChartTooltip({ props }: { props: any }) {
    if (!props.active || !props.payload) {
        return null;
    }

    const x_value = props.payload[0].payload.endDate;
    const y_value = props.payload[0].payload.percentValue;

    return (
        <span>
            <span style={{ opacity: 0.7 }}>{x_value}</span>
            <span>
                <strong style={{ marginLeft: `5px` }}>{y_value}</strong>
            </span>
        </span>
    );
}
